// import * as React from 'react';
// import Box from '@mui/material/Box';
// import TextField from '@mui/material/TextField';
// import { InputLabel } from '@mui/material';

// export default function EditableTextFieldss() {
//   return (
//     <Box
//       component="form"
//       sx={{
//         '& .MuiTextField-root': { m: 2, width:"46rem" ,margin:"8px 0px 0px -3px"},
//       }}
//       noValidate
//       autoComplete="off"
//     >
//       <div>
//       {/* <InputLabel className='__Input-label' id="label">Message body</InputLabel> */}
//         <TextField
//           id="outlined-multiline-static"
//           label="Message body"
//           multiline
//           rows={3}
//           defaultValue=""
//           placeholder='Message body'
//         />
//       </div>
//     </Box>
//   );
// }

import React from "react";
import ReactDOM from "react-dom";
import ContentEditable from "react-contenteditable";
import sanitizeHtml from "sanitize-html";
import "./style.css";
import { InputLabel } from "@mui/material";

class EditableTextFieldss extends React.Component {
  constructor(props) {
    super();
    this.state = {
      text:"",
      html: `<p></p>`,
      editable: true,
   
    };
  }
  handleChange = evt => {
    this.setState({ html: evt.target.value });
    this.props.onChange(evt)
  };

  sanitizeConf = {
    allowedTags: ["b", "i", "em", "strong", "a", "p", "h1"],
    allowedAttributes: { a: ["href",'name', 'target'] },
  };

  sanitize = () => {
    this.setState({ html: sanitizeHtml(this.state.html, this.sanitizeConf) });
  };


  pastText =(evt)=>{
    // this.setState({ text: evt });
    let dirty = this.state.html+`<h2>'<'${evt}'>'</h2>`;

    this.setState({ html: sanitizeHtml(dirty, this.sanitizeConf) });


  }

  componentDidMount(){
    this.setState({ html: sanitizeHtml(this.props.messageText, this.sanitizeConf) });

  }


  // toggleEditable = () => {
  //   this.setState({ editable: !this.state.editable });
  // };

  render = () => {
    return (
      <div>
        <InputLabel className='__Input-label' id="label">Message body</InputLabel>
        <ContentEditable
          className="editable"
          tagName="article"
          html={this.state.html} // innerHTML of the editable div
          disabled={!this.state.editable} // use true to disable edition
          onChange={this.handleChange} // handle innerHTML change
          // onBlur={this.sanitize}
          placeholder="Message body"

        />
        <div className="tagdiv">
              {/* <EditButton cmd="italic" name="italic"/>
        <EditButton cmd="bold" name="bold"/> */}
        <EditButton cmd="copy" name="RMN"  arg="abcd" fun={this.pastText}/>
        <EditButton cmd="paste" name="Profile Name" arg="abcd"  fun={this.pastText}/>
        <EditButton cmd="paste" name="Subcription End Date" arg="abcd"  fun={this.pastText}/>

        </div>
      </div>
    );
  };
}

function EditButton(props) {
  const [value, setValue] = React.useState("");

  return (
    <button
    key={props.cmd}
    onMouseDown={evt => {
      evt.preventDefault(); // Avoids loosing focus from the editable area
      document.execCommand(props.cmd, false, props.arg); // Send the command to the browser
      props.fun(props.name )
    }}
    style={{"cursor": "pointer"}}
    >
      {props.name || props.cmd}
    </button>
  );
}

export default EditableTextFieldss
